import { suppliesSubscriptionIdFormat } from "@redotech/redo-marketplace-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const skipSuppliesSubscriptionOrder = {
  name: "skipSuppliesSubscriptionOrder" as const,
  input: z.object({ subscriptionId: suppliesSubscriptionIdFormat.schema }),
  output: z.object({ nextReorderDate: zExt.plainDate() }),
};
